import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TransactionalEventsService } from '@core/services/transactional-events.service';
import {
  TransactionalEventsEditComponent,
} from '@modules/transactional-events/transactional-events-edit/transactional-events-edit.component';
import { Constants } from '@shared/class/constants.class';
import { TransactionalEvent } from '@shared/interfaces/transactional-event';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-transactional-events-list',
  templateUrl: './transactional-events-list.component.html'
})
export class TransactionalEventsListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'transactionalEvents';
  public dataSource: MatTableDataSource<TransactionalEvent>;
  public selection = new SelectionModel<TransactionalEvent>(true, []);
  public transactionalEventsList: Array<TransactionalEvent> = [];
  public transactionalEvent: TransactionalEvent;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public transactionalEventsService: TransactionalEventsService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );

          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.transactionalEventsService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.transactionalEventsList = [];
          result.data.forEach((element: any) => {
            this.transactionalEvent = {
              id: element.id,
              name: element.attributes.name
            };
            this.transactionalEventsList.push(this.transactionalEvent);
          });
          if (this.transactionalEventsList.length) {
            this.dataSource = new MatTableDataSource(
              this.transactionalEventsList
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: TransactionalEvent) {
    let dialog: any;

    const data = {
      action: action,
      item: {}
    };

    if (action === this.appConfig.ACTIONS.add.id) {
      this.constants.message = this.appConfig.LANG.message.addSuccess;
    } else {
      data.item = item;
      this.constants.message = this.appConfig.LANG.message.editSuccess;
    }

    dialog = this.generalsService.modal(TransactionalEventsEditComponent, data);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.generalsService.afterClosed(this, result, this.constants.message);
      });
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
